var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturedIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_74_4853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47715 6.47715 1 12 1H40C45.5228 1 50 5.47715 50 11V39C50 44.5228 45.5228 49 40 49H12C6.47715 49 2 44.5228 2 39V11Z",
    fill: "url(#paint0_linear_74_4853)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 34V28.6C29 28.0399 29 27.7599 28.891 27.546C28.7951 27.3578 28.6422 27.2049 28.454 27.109C28.2401 27 27.9601 27 27.4 27H24.6C24.0399 27 23.7599 27 23.546 27.109C23.3578 27.2049 23.2049 27.3578 23.109 27.546C23 27.7599 23 28.0399 23 28.6V34M33 34V19.2C33 18.0799 33 17.5198 32.782 17.092C32.5903 16.7157 32.2843 16.4097 31.908 16.218C31.4802 16 30.9201 16 29.8 16H22.2C21.0799 16 20.5198 16 20.092 16.218C19.7157 16.4097 19.4097 16.7157 19.218 17.092C19 17.5198 19 18.0799 19 19.2V34M35 34H17M23.5 21H23.51M28.5 21H28.51M24 21C24 21.2761 23.7761 21.5 23.5 21.5C23.2239 21.5 23 21.2761 23 21C23 20.7239 23.2239 20.5 23.5 20.5C23.7761 20.5 24 20.7239 24 21ZM29 21C29 21.2761 28.7761 21.5 28.5 21.5C28.2239 21.5 28 21.2761 28 21C28 20.7239 28.2239 20.5 28.5 20.5C28.7761 20.5 29 20.7239 29 21Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_74_4853",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_74_4853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_74_4853",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_4853",
    x1: 50,
    y1: 1,
    x2: -3.14295,
    y2: 19.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6045CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#606CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#4B8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32D3A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIcon1);
export default __webpack_public_path__ + "static/media/featured_icon_1.be9138249a96b3c00d9a2979903cf5cc.svg";
export { ForwardRef as ReactComponent };